@let savingDrawer = savingDrawer$ | async;
<nz-drawer
  [nzVisible]="(bulkCreateDrawerVisible$ | async) === true"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzPlacement]="'right'"
  [nzClosable]="false"
  [nzTitle]="'general.add' | translate"
  [nzSize]="'large'"
  [nzFooter]="drawerFooter"
  (nzOnClose)="closeBulkCreateDrawer()"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical">
      <!-- Select Users -->
      <nz-collapse nzGhost>
        <nz-collapse-panel
          nzCollapsible="icon"
          [nzHeader]="'general.staff' | translate"
          [nzActive]="true"
        >
          <div nz-row [nzGutter]="16" nzAlign="bottom">
            <div nz-col nzSpan="24" class="wilson-users-select-col">
              <wilson-qualifications-v2-multi-users-select
                [label]="'general.search' | translate"
                [formControl]="userIdsFormControl"
                [hideSelected]="false"
                [listOfSelected]="userIdList"
                (selectedIdsChange)="handleUserSelection($event)"
              ></wilson-qualifications-v2-multi-users-select>
            </div>
          </div>
        </nz-collapse-panel>
      </nz-collapse>

      <hr />

      <!-- Select Qualifications -->
      <nz-collapse nzGhost>
        <nz-collapse-panel
          nzCollapsible="icon"
          [nzHeader]="'general.qualifications' | translate"
          [nzActive]="true"
        >
          <div nz-row [nzGutter]="16" nzAlign="bottom">
            <div nz-col nzSpan="24">
              <wilson-qualification-v2-select
                [placeholder]="'general.search' | translate"
                [formControl]="qualificationFormControl"
              ></wilson-qualification-v2-select>
            </div>
          </div>
        </nz-collapse-panel>
      </nz-collapse>

      <hr />

      <wilson-bulk-qualifications-dates-and-approval-section
        [acquiredAtFormControl]="acquiredAtFormControl"
        [validFromFormControl]="validFromFromControl"
        [validUntilFormControl]="validUntilFormControl"
        [infiniteValidFormControl]="infiniteValidFormControl"
        [confirmedByEmployeeFormControl]="confirmedByEmployeeFormControl"
      ></wilson-bulk-qualifications-dates-and-approval-section>

      <hr />

      <wilson-bulk-qualifications-attachment-section
        [(fileList)]="attachmentsList"
        [disabledNzUpload]="savingDrawer"
        [disabledFileList]="savingDrawer"
      ></wilson-bulk-qualifications-attachment-section>

      <hr />

      <wilson-bulk-qualifications-notes-section
        [notesFormControl]="notesFormControl"
      ></wilson-bulk-qualifications-notes-section>
    </form>
  </ng-container>
</nz-drawer>

<ng-template #drawerFooter>
  <wilson-bulk-qualifications-footer-section
    (cancelDrawer)="cancelDrawer()"
    (saveDrawer)="saveDrawer()"
    [saveButtonDisabled]="
      !userIdList.length ||
      !qualificationFormControl.value?.length ||
      !acquiredAtFormControl.value ||
      !validFromFromControl.value ||
      !validUntilFormControl.value
    "
    [loading]="savingDrawer"
  >
  </wilson-bulk-qualifications-footer-section>
</ng-template>
